module.exports = "././fonts/a9fc51fd0214c75ee5953dda0f2a06a6.woff";


//////////////////
// WEBPACK FOOTER
// ../fonts/roboto-v16-latin-regular.woff
// module id = 1131
// module chunks = 0